import type { SelectOption } from '@rio-cloud/rio-uikit/Select';

import type { BulkMaterialUnitType } from '#domain/BulkMaterialUnitType.ts';

export const unitOptions = [
    {
        id: 'cubic-meter',
        label: 'm³',
        selected: true,
    },
    {
        id: 'liter',
        label: 'l',
    },
    {
        id: 'kilogram',
        label: 'kg',
    },
    {
        id: 'ton',
        label: 't',
    },
] satisfies Array<SelectOption & { id: BulkMaterialUnitType }>;
